// extracted by mini-css-extract-plugin
export default {"active":"Nav_active__5I5vw"};